import React, { Component } from 'react';
import { connect } from 'react-redux';
import apiV2 from '../../utils/apiV2';
import searchicon from '../../assets/images/Managebooks/searchicon.svg';
import Polygon from '../../assets/images/Managebooks/Polygon.svg';
import Moment from 'react-moment';
import LottieAnimation from '../../components/Lottie/lottieAnimation';
import Box from '@mui/material/Box';

var cx = require('classnames');

class PaperBackSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            isLoading: false,
            errors: {},
            search: '',
            sortByName: false,
            sortByDate: false,
            sortByStatus: false,
            sortByOrderId: false,
            sortByPrice: false,
            currentPage: 1,
            todosPerPage: 10,
            OrderListFiltered: [],
            earning: 0,
            cleared: 0,
            pending: 0
        };
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.fetchOrders();
    }

    fetchOrders = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await apiV2.get('/api/publisher/paperback/order');
            console.log('Orders Response:', response.data);
            
            // API response structure: { data: [...] }
            if (response.data && response.data.data) {
                const orders = Array.isArray(response.data.data) ? response.data.data : [];
                this.setState({
                    orders: orders,
                    isLoading: false
                }, () => {
                    this.getTotalEarning(orders);
                    // Sort by date descending by default
                    let sortedOrders = orders.sort(this.sortArrByOrder('createdAt', 'DESC'));
                    this.setState({ 
                        orders: sortedOrders,
                        ["SORT" + 'createdAt']: 'DESC'
                    });
                });
            } else {
                this.setState({
                    orders: [],
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
            this.setState({
                errors: error.response?.data || { msg: 'Something went wrong' },
                isLoading: false,
                orders: []
            });
        }
    }

    sortArrByOrder = (prop, order) => {
        if (order === "ASC") {
            return function (a, b) {
                let date1 = new Date(a.createdAt || a.order?.createdAt || 0);
                let date2 = new Date(b.createdAt || b.order?.createdAt || 0);
                return date1 - date2;
            };
        }
        return function (a, b) {
            let date1 = new Date(a.createdAt || a.order?.createdAt || 0);
            let date2 = new Date(b.createdAt || b.order?.createdAt || 0);
            return date2 - date1;
        };
    }

    onSort = (name, order) => {
        this.setState({ ["SORT" + name]: order });
        let { orders, OrderListFiltered } = this.state;
        let ordersSorted = orders.sort(this.sortArrByOrder(name, order));
        let OrderListFilteredSorted = OrderListFiltered.sort(this.sortArrByOrder(name, order));
        this.setState({ orders: ordersSorted, OrderListFiltered: OrderListFilteredSorted });
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value }, () => {
            this.onSearch(e.target.value);
        });
    }

    onSearch = async (searchStr) => {
        if (!searchStr) {
            this.setState({ OrderListFiltered: [] });
            return;
        }
        let { orders } = this.state;
        let filteredList = orders.filter((item) => {
            const bookName = item?.paperback?.Name?.toLowerCase() || '';
            const orderId = item?.Order_ID?.toLowerCase() || '';
            const searchLower = searchStr.toLowerCase();
            return bookName.includes(searchLower) || orderId.includes(searchLower);
        });
        this.setState({
            currentPage: 1,
            OrderListFiltered: filteredList
        });
    }

    getTotalEarning = (list) => {
        if (list && list.length > 0) {
            var earning = 0;
            var cleared = 0;
            for (var i = 0; i < list.length; i++) {
                const item = list[i];
                const amount = parseInt(item?.bookAmount || 0);
                earning = earning + amount;
                
                // If status is Cleared, add to cleared
                if (item?.Status === 'Cleared') {
                    cleared = cleared + amount;
                }
            }
            this.setState({ 
                earning: earning, 
                cleared: cleared,
                pending: earning - cleared
            });
        } else {
            this.setState({ 
                earning: 0, 
                cleared: 0,
                pending: 0
            });
        }
    }

    handleClick = (type) => {
        if (type === 'next') {
            this.setState({
                currentPage: this.state.currentPage + 1
            });
        } else if (type === 'previous') {
            this.setState({
                currentPage: this.state.currentPage - 1
            });
        }
    }

    renderTableRows = (list) => {
        if (!list || list.length < 1) {
            return (
                <tr>
                    <td className="text-center" colSpan="8">
                        <b className="table-text">No Result</b>
                    </td>
                </tr>
            );
        }

        return list.map((item, i) => (
            <tr key={item.ID || i}>
                <td>
                    <img 
                        src={item?.paperback?.Image || 'https://via.placeholder.com/50'} 
                        width="50px" 
                        alt="book cover"
                    />
                </td>
                <td>{item?.paperback?.Name || 'N/A'}</td>
                <td>{item?.Order_ID || 'N/A'}</td>
                <td>
                    {item?.createdAt ? (
                        <Moment format="DD-MM-YY HH:mm:ss">
                            {new Date(item.createdAt.slice ? item.createdAt.slice(0, -1) : item.createdAt)}
                        </Moment>
                    ) : (
                        'N/A'
                    )}
                </td>
                <td>
                    {item?.bookAmount ? (
                        <span>{item.bookAmount} PKR</span>
                    ) : (
                        'N/A'
                    )}
                </td>
                <td>
                    <div className={cx({
                        "table-badge-publish": item?.Status === 'Cleared',
                        "table-badge-review": item?.Status === 'Pending',
                        "table-badge-blocked": item?.Status === 'Cancelled' || item?.Status === 'Failed'
                    })}>
                        <label className="badge-label">
                            {item?.Status || 'Pending'}
                        </label>
                    </div>
                </td>
                <td>
                    <Box
                        className='myBox'
                        sx={{
                            bgcolor: `${item?.Status === 'Cleared' ? '#0E7542' : '#FAC85B'}`,
                        }}
                    >
                        <label className="badge-label2">
                            {item?.Status === 'Cleared' ? 'Paid' : 'Unpaid'}
                        </label>
                    </Box>
                </td>
                <td>
                    {item?.Reference_No || item?.order?.Reference_No || 'No Payment Yet'}
                </td>
            </tr>
        ));
    }

    render() {
        const { isLoading, orders, currentPage, todosPerPage, OrderListFiltered, search, earning, cleared, pending } = this.state;

        if (isLoading && orders.length === 0) {
            return <LottieAnimation />;
        }

        let printList = search ? OrderListFiltered : orders;

        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const currentTodos = printList.slice(indexOfFirstTodo, indexOfLastTodo);

        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(printList.length / todosPerPage); i++) {
            pageNumbers.push(i);
        }

        return (
            <div>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 managebookContainer">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                                <p className="poppins_semibold managebookheading">Paperback Sales</p>
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0 mt-4">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
                                        <div className="SellingHistoryTopBarCard">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="EaringRs">
                                                    {earning === 0 ? '0.00 RS' : earning + '.00 RS'}
                                                </p>
                                                <p className="totalEaring">Total Earning</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
                                        <div className="SellingHistoryTopBarCard">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="PendingRs">
                                                    {cleared === 0 ? '0.00 RS' : cleared + '.00 RS'}
                                                </p>
                                                <p className="totalEaring">Total Cleared</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
                                        <div className="SellingHistoryTopBarCard">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <p className="PendingRs colorPending">
                                                    {pending + '.00 RS'}
                                                </p>
                                                <p className="totalEaring">Total Pending</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3 managebookContainer">
                            <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-4 AllbookContainer">
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                                <p className="Allbook-heading mb-0">History</p>
                                                <p className="allbooktext mb-0">All paperback sales history</p>
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                                <div className="row">
                                                    <div className="col-xl-5 col-lg-5 col-md-5 col-sm-4 col-4"></div>
                                                    <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12 text-right">
                                                        <input 
                                                            className="search_input" 
                                                            placeholder="search here" 
                                                            name="search" 
                                                            value={search}
                                                            onChange={this.onChange}
                                                        />
                                                        <img className="searchicon" src={searchicon} alt="search" />
                                                        <button 
                                                            className="allbook-search-btn"
                                                            onClick={() => this.onSearch(this.state.search)}
                                                        >
                                                            search
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-3 AllbookContainer">
                                        <div className="table-responsive mt-4 checkout_container">
                                            <table className="table table-hover thead-primary">
                                                <thead>
                                                    <tr>
                                                        <th scope="col table_header poppins_medium">Book Title</th>
                                                        <th scope="col table_header poppins_medium">Book Name</th>
                                                        <th scope="col table_header poppins_medium">Order ID</th>
                                                        {this.state["SORT" + "createdAt"] === "DESC" ? (
                                                            <th 
                                                                onClick={(e) => this.onSort('createdAt', 'ASC')} 
                                                                scope="col table_header poppins_medium"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                Date & Time
                                                                <span><i className="fa fa-caret-down" aria-hidden="true"></i></span>
                                                            </th>
                                                        ) : (
                                                            <th 
                                                                onClick={(e) => this.onSort('createdAt', 'DESC')} 
                                                                scope="col table_header poppins_medium"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                Date & Time
                                                                <span><i className="fa fa-caret-up" aria-hidden="true"></i></span>
                                                            </th>
                                                        )}
                                                        <th scope="col table_header poppins_medium">Amount</th>
                                                        <th scope="col table_header poppins_medium">Payment Status</th>
                                                        <th scope="col table_header poppins_medium">Author Payment Status</th>
                                                        <th scope="col table_header poppins_medium">Reference No.</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orders.length > 0 && this.renderTableRows(currentTodos)}
                                                    {orders.length < 1 && (
                                                        <tr>
                                                            <td className="text-center" colSpan="8">
                                                                <b className="table-text">No Data To Display</b>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-3">
                                                        <div className="row">
                                                            <div className="col-xl-3 col-lg-2 col-md-2 col-sm-2 col-2">
                                                                <button 
                                                                    className="navbtn" 
                                                                    onClick={(e) => this.handleClick('previous')} 
                                                                    disabled={currentPage === 1}
                                                                >
                                                                    ← Previous
                                                                </button>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-8 col-md-8 col-sm-8 col-8 pb-3">
                                                                <label className="poppins_bold">{currentPage}</label>
                                                                <label className="poppins_regular ml-3 mr-3">out of</label>
                                                                <label className="poppins_bold">{pageNumbers.length}</label>
                                                            </div>
                                                            <div className="col-xl-3 col-lg-2 col-md-2 col-sm-2 col-2">
                                                                <button 
                                                                    className="navbtn" 
                                                                    onClick={(e) => this.handleClick('next')} 
                                                                    disabled={currentPage === pageNumbers.length}
                                                                >
                                                                    Next →
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps)(PaperBackSales);
